// App Switcher (PO1-2059) — items renderizados dentro do dropdown "Trocar
// Para" do AdminNavbar. Cada produto contratado pelo embarcador vira uma
// opção; o ativo destaca cor + negrito. Respeita tema claro/escuro via
// tokens --everlog-* em AppSwitcher.css.

import React from "react";
import { DropdownItem, NavLink } from "reactstrap";
import { useFeatures } from "../../hooks/features";
import { useActiveProduct } from "../../hooks/activeProduct";
import { getSwitcherProducts } from "../../routes/products";

import "./AppSwitcher.css";

const AppSwitcher = () => {
  const { codes, loading } = useFeatures();
  const { activeProduct, setActiveProduct } = useActiveProduct();

  if (loading) return null;
  const products = getSwitcherProducts(codes);
  if (products.length === 0) return null;

  return products.map((p) => {
    const isActive = p.code === activeProduct;
    const Icon = p.icon;
    return (
      <NavLink key={p.code} tag="li">
        <DropdownItem
          tag="a"
          href="#"
          className={
            "app-switcher-item" +
            (isActive ? " app-switcher-item--active" : "")
          }
          // Cor da marca (azul Flow, verde GoBid, etc.) aplica só no item
          // ativo — pinta texto + ícone + barra lateral via currentColor.
          // Inativos herdam --everlog-card-text do tema.
          style={isActive ? { color: p.color, borderLeftColor: p.color } : undefined}
          onClick={(e) => {
            e.preventDefault();
            setActiveProduct(p.code);
          }}
        >
          <span
            className="app-switcher-item__icon"
            // Ícone fica colorido sempre (mesmo inativo) — cor da marca do
            // produto facilita reconhecimento.
            style={{ color: p.color }}
          >
            {p.iconImage ? (
              // objectFit:contain preserva o aspect ratio do PNG (logos não
              // quadrados ficariam distorcidos num <img> width=height=22).
              <img
                src={p.iconImage}
                alt=""
                style={{ width: 22, height: 22, objectFit: "contain" }}
              />
            ) : Icon ? (
              <Icon size={22} />
            ) : null}
          </span>
          {p.label}
        </DropdownItem>
      </NavLink>
    );
  });
};

export default AppSwitcher;
